import { createVoltraComponent } from './createVoltraComponent.js'
import type { GlassContainerProps } from './props/GlassContainer.js'

export type { GlassContainerProps }
export const GlassContainer = createVoltraComponent<GlassContainerProps>('GlassContainer')
